// src/pages/Home.jsx
import { Link, useNavigate } from 'react-router-dom'
import { FaBriefcase, FaReact, FaHtml5, FaCss3Alt, FaGithub, FaMobileAlt, FaCheckCircle, FaUsers, FaCode, FaRocket, FaStar, FaEnvelope, FaLinkedin, FaBars, FaTimes, FaUniversalAccess } from 'react-icons/fa'
import { SiTailwindcss, SiSupabase, SiJavascript, SiBootstrap, SiPhp } from 'react-icons/si'
import Tilt from 'react-parallax-tilt'
import { useRef, useState } from 'react'
import { TypeAnimation } from 'react-type-animation'

const projects = [
  {
    title: 'RBApps - HR Management System',
    description: 'Aplikasi manajemen HR lengkap dengan fitur timesheet, leave management, CV builder, dan document generator. Platform all-in-one untuk kebutuhan HR perusahaan modern dengan dashboard analytics yang powerful.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop',
    link: '/hr-management',
    tech: ['React', 'Supabase', 'Tailwind CSS', 'React Router'],
    stats: { duration: '2 bulan', team: '1 orang', status: 'Production' },
    isLive: true
  },
  // {
  //   title: 'Enterprise Resource Planning System',
  //   description: 'Sistem ERP komprehensif dengan manajemen inventory, HR, dan keuangan. Dibangun dengan React, TypeScript, dan integrasi real-time database untuk perusahaan manufaktur.',
  //   image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop',
  //   link: '#',
  //   tech: ['React', 'TypeScript', 'Supabase', 'Tailwind CSS'],
  //   stats: { duration: '6 bulan', team: '4 orang', status: 'Production' }
  // },
  {
    title: 'E-commerce Platform',
    description: 'Platform marketplace multi-vendor dengan payment gateway dan sistem rating. Mendukung 10,000+ transaksi per bulan dengan performa optimal.',
    image: 'https://images.unsplash.com/photo-1557821552-17105176677c?w=600&h=400&fit=crop',
    link: 'https://jastipin.rbapps.me',
    tech: ['PHP', 'MySQL'],
    stats: { duration: '1 bulan', team: '1 orang', status: 'Production' }
  },
  // {
  //   title: 'Healthcare Management System',
  //   description: 'Aplikasi manajemen rumah sakit dengan appointment booking, medical records, dan telemedicine. Memenuhi standar keamanan data kesehatan HIPAA.',
  //   image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop',
  //   link: '#',
  //   tech: ['React', 'Express', 'MongoDB', 'WebRTC'],
  //   stats: { duration: '10 bulan', team: '8 orang', status: 'Production' }
  // },
  // {
  //   title: 'Financial Analytics Dashboard',
  //   description: 'Dashboard analitik keuangan real-time dengan visualisasi data kompleks, predictive analytics, dan automated reporting untuk institusi keuangan.',
  //   image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop',
  //   link: '#',
  //   tech: ['React', 'D3.js', 'Python', 'TensorFlow'],
  //   stats: { duration: '5 bulan', team: '5 orang', status: 'Production' }
  // },
  // {
  //   title: 'Learning Management System',
  //   description: 'Platform e-learning dengan video streaming, quiz interaktif, progress tracking, dan gamification. Melayani 50,000+ siswa aktif.',
  //   image: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=600&h=400&fit=crop',
  //   link: '#',
  //   tech: ['React', 'Firebase', 'AWS S3', 'Stripe'],
  //   stats: { duration: '7 bulan', team: '6 orang', status: 'Production' }
  // },
]

// eslint-disable-next-line no-unused-vars
const carouselItems = [
  {
    title: 'Landing Page',
    image: 'https://source.unsplash.com/600x400/?landing',
    description: 'Desain landing page modern dengan CTA kuat dan layout responsif.',
  },
  {
    title: 'Blog Platform',
    image: 'https://source.unsplash.com/600x400/?blog',
    description: 'Platform blogging dengan editor markdown dan manajemen konten.',
  },
  {
    title: 'Mobile App UI',
    image: 'https://source.unsplash.com/600x400/?mobile-app',
    description: 'UI aplikasi mobile yang sleek untuk pengalaman pengguna optimal.',
  },
]

// eslint-disable-next-line no-unused-vars
const heroBackground =
  "https://images.unsplash.com/photo-1522199710521-72d69614c702?auto=format&fit=crop&w=1600&q=80";

export default function Home() {
  const typedRef = useRef(null) // eslint-disable-line no-unused-vars
  const navigate = useNavigate()
  const [selectedProject, setSelectedProject] = useState(null)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const openModal = (project) => {
    if (project.isLive) {
      navigate(project.link)
    } else {
      setSelectedProject(project)
    }
  }
  const closeModal = () => setSelectedProject(null)

  const workHistory = [
    {
      title: 'Technical Project Admin',
      company: 'PT. Adidata Informatika',
      year: '2023 - Now',
      description: 'A Technical Project Admin at Bank Syariah Indonesia plays a key supporting role in the execution, documentation, and monitoring of technology-driven projects. This position acts as a bridge between project managers, IT teams, business units, and external vendors to ensure that projects—particularly those related to digital banking systems, IT infrastructure, and technology integration—are delivered in accordance with project standards, regulatory requirements, and Sharia compliance.',
      achievements: [
        'Created and maintained Software Design Documents (SDD) to provide clear technical specifications for development teams.',
        'Prepared internal memos and reports to effectively communicate project updates and technical details.',
        'Performed application testing, including functional and user acceptance testing (UAT), to ensure software quality before release.',
        'Collaborated with cross-functional teams at Bank BSI to support application development and implementation.'
      ]
    },
    {
      title: 'Technical Writer',
      company: 'PT. Mitra Konsultansi Indonesia',
      year: '2020 - 2022',
      description: 'A Technical Writer is a professional responsible for creating, organizing, and simplifying technical information so it can be easily understood by users. They transform complex concepts into clear, structured, and user-friendly documentation for various audiences — from general users to engineers or developers.',
      achievements: [
        'Created Functional Specification Documents (FSD), Technical Specification Documents (TSD), Software Requirements Specifications (SRS), Business Requirements Documents (BRD), and User Guides to support development and user adoption.',
        'Collaborated closely with development teams, Business Analysts (BA), and Quality Assurance (QA) to ensure project alignment and quality deliverables.',
        'Designed diagrams and use case models to visually represent system functionality and user interactions.',
        'Conducted application testing to identify bugs and verify that features meet requirements.'
      ]
    },
    {
      title: 'Junior Java Developer',
      company: 'PT. Samudera Anugerah',
      year: '2017 - 2018',
      description: 'Developed responsive web applications using Spring Tool Suite (STS), JavaScript, and Bootstrap, while collaborating effectively with cross-functional teams.',
      achievements: [
        'Developed applications to meet client requirements and business needs.',
        'Conducted application testing to ensure functionality, performance, and reliability.',
        'Implemented applications, including deployment and configuration in production environments.',
        'Provided ongoing support for application development, troubleshooting, and maintenance.'
      ]
    },
  ]

  const skills = [
    { label: 'React.js', icon: <FaReact />, level: 'Expert', years: '5+' },
    // { label: 'TypeScript', icon: <SiTypescript />, level: 'Expert', years: '4+' },
    // { label: 'Next.js', icon: <SiNextdotjs />, level: 'Advanced', years: '3+' },
    { label: 'Bootstrap', icon: <SiBootstrap />, level: 'Advanced', years: '3+' },
    { label: 'Tailwind CSS', icon: <SiTailwindcss />, level: 'Expert', years: '4+' },
    { label: 'JavaScript', icon: <SiJavascript />, level: 'Expert', years: '6+' },
    // { label: 'Node.js', icon: <SiNodedotjs />, level: 'Advanced', years: '3+' },
    { label: 'HTML5', icon: <FaHtml5 />, level: 'Expert', years: '6+' },
    { label: 'CSS3', icon: <FaCss3Alt />, level: 'Expert', years: '6+' },
    { label: 'Supabase', icon: <SiSupabase />, level: 'Advanced', years: '2+' },
    // { label: 'Git & GitHub', icon: <FaGithub />, level: 'Expert', years: '5+' },
    { label: 'Responsive Design', icon: <FaMobileAlt />, level: 'Expert', years: '5+' },
    { label: 'Web Performance', icon: <FaRocket />, level: 'Advanced', years: '3+' },
    { label: 'Accessibility', icon: <FaUniversalAccess />, level: 'Advanced', years: '3+' },
    { label: 'PHP', icon: <SiPhp />, level: 'Intermediate', years: '2+' },
    { label: 'Problem Solving', icon: <FaCode />, level: 'Expert', years: '5+' },
    { label: 'Team Collaboration', icon: <FaUsers />, level: 'Expert', years: '5+' },
    { label: 'Clean Code', icon: <FaStar />, level: 'Expert', years: '5+' },
  ]

  return (
    <div className="min-h-screen bg-white relative overflow-hidden">
      {/* Floating Gradient Orbs Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-blue-100/40 via-blue-100/40 to-blue-100/40 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-gradient-to-tl from-blue-100/40 via-pink-100/40 to-blue-100/40 rounded-full blur-3xl animate-float-delayed"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-cyan-50/30 via-blue-50/30 to-blue-50/30 rounded-full blur-3xl animate-float-slow"></div>
        
        {/* Grid Pattern */}
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(99, 102, 241, 0.02) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(99, 102, 241, 0.02) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      {/* Animated CSS */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(20px, -20px) scale(1.1); }
          66% { transform: translate(-15px, 15px) scale(0.9); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(-25px, 20px) scale(1.05); }
          66% { transform: translate(20px, -15px) scale(0.95); }
        }
        @keyframes float-slow {
          0%, 100% { transform: translate(-50%, -50%) scale(1); }
          50% { transform: translate(-50%, -50%) scale(1.1); }
        }
        .animate-float { animation: float 8s ease-in-out infinite; }
        .animate-float-delayed { animation: float-delayed 10s ease-in-out infinite; }
        .animate-float-slow { animation: float-slow 12s ease-in-out infinite; }
      `}</style>
      {/* Navbar */}
      <nav className="relative backdrop-blur-xl bg-white/80 shadow-lg border-b border-white/40 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 bg-clip-text text-transparent">
            Bayu Muhammad Akbar
          </h1>
          
          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#home" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-300">Home</a>
            <a href="#work" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-300">Experience</a>
            <a href="#skills" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-300">Skills</a>
            <a href="#projects" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-300">Projects</a>
            <a href="#about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-300">About</a>
          </div>

          <div className="flex items-center gap-4">
            {/* Desktop Contact Button */}
            <a
              href="#contact"
              className="hidden md:block group relative bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 hover:from-blue-700 hover:via-blue-700 hover:to-blue-700 text-white px-6 py-2.5 rounded-xl font-semibold transition-all duration-300 shadow-md hover:shadow-xl transform hover:scale-105 overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
              <span className="relative z-10">Contact Me</span>
            </a>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-gray-700 hover:text-blue-600 focus:outline-none"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <FaTimes className="w-6 h-6" />
              ) : (
                <FaBars className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
            isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="px-4 py-4 space-y-3 bg-white/95 backdrop-blur-xl border-t border-gray-200">
            <a
              href="#home"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg font-medium transition-all duration-200"
            >
              Home
            </a>
            <a
              href="#work"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg font-medium transition-all duration-200"
            >
              Experience
            </a>
            <a
              href="#skills"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg font-medium transition-all duration-200"
            >
              Skills
            </a>
            <a
              href="#projects"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg font-medium transition-all duration-200"
            >
              Projects
            </a>
            <a
              href="#about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg font-medium transition-all duration-200"
            >
              About
            </a>
            <a
              href="#contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 text-white text-center rounded-lg font-semibold shadow-md hover:shadow-lg transition-all duration-200"
            >
              Contact Me
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-20 px-4 text-center overflow-hidden min-h-[600px] flex items-center justify-center">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1920&q=80')`,
            }}
          ></div>
          {/* Gradient Overlay untuk elegant look dan readability */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/85 via-blue-900/80 to-blue-900/85"></div>
          {/* Pattern Overlay */}
          <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
                             linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px)`,
            backgroundSize: '50px 50px'
          }}></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-extrabold mb-6 leading-tight">
            <span className="bg-gradient-to-r from-white via-blue-100 to-blue-100 bg-clip-text text-transparent drop-shadow-lg">Welcome</span>
            <br />
            <span className="bg-gradient-to-r from-blue-200 via-blue-200 to-pink-200 bg-clip-text text-transparent drop-shadow-lg">to the Portfolio Application</span>
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-8 leading-relaxed drop-shadow-md">
            Platform portofolio profesional dengan <span className="font-semibold text-blue-200">a showcase of my work, passion, and journey in the world of technology.</span>
          </p>
          <div className="flex flex-wrap justify-center gap-8 mb-8 text-sm">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <FaCheckCircle className="text-green-400 text-xl drop-shadow-md" />
              <span className="text-white drop-shadow-md"><strong>100%</strong> Responsive</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <FaCheckCircle className="text-green-400 text-xl drop-shadow-md" />
              <span className="text-white drop-shadow-md"><strong>Real-time</strong> Updates</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <FaCheckCircle className="text-green-400 text-xl drop-shadow-md" />
              <span className="text-white drop-shadow-md"><strong>Enterprise</strong> Security</span>
            </div>
          </div>
          {/* <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a
              href="#projects"
              className="group relative inline-block bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 hover:from-blue-700 hover:via-blue-700 hover:to-blue-700 text-white px-10 py-4 rounded-2xl text-lg font-bold transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/25 to-white/0 transform -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
              <span className="relative z-10 flex items-center gap-2">
                My Projects
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>
            </a>
          </div> */}
        </div>
        
        {/* Decorative Elements - Adjusted for dark background */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-blue-400/20 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-32 h-32 bg-blue-400/20 rounded-full blur-xl animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-blue-400/15 rounded-full blur-2xl animate-pulse" style={{animationDelay: '0.5s'}}></div>
      </section>

      {/* Profil + Pengalaman Section */}
      <section
        id="home"
        className="relative min-h-screen flex flex-col md:flex-row items-center justify-between px-6 md:px-16 py-20"
      >
        <div className="md:w-1/2 text-center md:text-left space-y-6">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900">
            Hello, I'm <span className="text-blue-600">Bayu</span>!
          </h1>

          <p className="text-xl sm:text-2xl text-gray-700">
            <TypeAnimation
              sequence={[
                'Frontend Developer',
                1500,
                'React Enthusiast',
                1500,
                'UI Designer',
                1500,
              ]}
              wrapper="span"
              speed={50}
              repeat={Infinity}
              className="inline-block text-blue-600"
            />
          </p>

          <p className="text-gray-600 max-w-md leading-relaxed text-justify">
            <strong className="text-gray-800"> 5+ years of experience</strong> building <span className="font-medium text-blue-600">scalable</span> and 
            <span className="font-medium text-blue-600"> high-performance</span> web applications for enterprise clients. 
            Specialized in the <span className="font-medium text-blue-600">React ecosystem</span>, 
            <span className="font-medium text-blue-600"> TypeScript</span>, and 
            <span className="font-medium text-blue-600"> modern web architecture</span>.
          </p>
          
          <div className="grid grid-cols-3 gap-4 pt-4 max-w-md">
            <div className="text-center p-3 bg-gradient-to-br from-blue-50 to-blue-50 rounded-xl">
              <div className="text-2xl font-bold text-blue-600">50+</div>
              <div className="text-xs text-gray-600">Projects</div>
            </div>
            <div className="text-center p-3 bg-gradient-to-br from-blue-50 to-blue-50 rounded-xl">
              <div className="text-2xl font-bold text-blue-600">30+</div>
              <div className="text-xs text-gray-600">Clients</div>
            </div>
            <div className="text-center p-3 bg-gradient-to-br from-blue-50 to-pink-50 rounded-xl">
              <div className="text-2xl font-bold text-blue-600">5+</div>
              <div className="text-xs text-gray-600">Years</div>
            </div>
          </div>

            {/* <div className="flex flex-wrap gap-4 justify-center md:justify-start pt-6">
              <Link
                to="/login"
                className="group relative flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 hover:from-blue-700 hover:via-blue-700 hover:to-blue-700 text-white font-bold rounded-2xl transition-all duration-300 shadow-lg hover:shadow-2xl transform hover:scale-105 overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                <FaRocket className="relative z-10 group-hover:rotate-12 transition-transform duration-300" />
                <span className="relative z-10">Explore RBApps</span>
              </Link>

              <a
                href="#projects"
                className="group relative flex items-center gap-2 px-8 py-4 border-2 border-blue-600 text-blue-600 hover:bg-blue-50 font-bold rounded-2xl transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105"
              >
                <FaBriefcase className="group-hover:rotate-12 transition-transform duration-300" />
                <span>View Portfolio</span>
              </a>
            </div> */}
        </div>

        <div className="md:w-1/2 mt-14 md:mt-0 flex flex-col items-center relative">
          <Tilt
            glareEnable={true}
            glareMaxOpacity={0.2}
            scale={1.05}
            transitionSpeed={1000}
            tiltMaxAngleX={10}
            tiltMaxAngleY={10}
          >
            <div className="relative bg-white rounded-xl shadow-xl p-4 w-64 sm:w-80 transform transition hover:shadow-2xl hover:-translate-y-2 hover:ring-4 hover:ring-blue-400">
              <img
                src="/assets/images/sample-profile.jpg"
                alt="Foto Bayu"
                className="w-full h-72 sm:h-80 object-cover rounded-xl -mt-10 border-4 border-blue-500 hover:brightness-105 transition duration-300"
              />
            </div>
          </Tilt>
          <div className="mt-4 text-center">
            <h3 className="text-xl font-bold text-gray-800">Bayu Muhammad Akbar</h3>
            <p className="text-gray-600 text-sm">Web Developer</p>
          </div>
        </div>
      </section>

      {/* Pengalaman Kerja */}
      <section id="work" className="relative py-20 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">
            <span className="bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 bg-clip-text text-transparent">EXPERIENCE</span>
          </h2>

          <div className="relative border-l-4 border-gradient-to-b from-blue-600 via-blue-600 to-blue-600 pl-6 space-y-12">
            {workHistory.map((item, index) => (
              <div
                key={index}
                className="relative group"
              >
                <div className="absolute -left-9 top-2 w-8 h-8 bg-gradient-to-br from-blue-600 to-blue-600 rounded-full flex items-center justify-center text-white shadow-lg group-hover:scale-125 transition-transform duration-300">
                  <FaBriefcase size={14} />
                </div>
                <div className="relative backdrop-blur-xl bg-white/70 p-6 rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-300 border border-white/40 overflow-hidden transform group-hover:-translate-y-1">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 to-blue-500/0 group-hover:from-blue-500/5 group-hover:to-blue-500/5 transition-all duration-500"></div>
                  <div className="relative z-10">
                    <h3 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-blue-600 bg-clip-text text-transparent">
                      {item.title}
                    </h3>
                    <p className="text-sm text-blue-600 font-semibold mb-1">{item.company}</p>
                    <p className="text-sm text-gray-500 mb-3 italic font-medium">{item.year}</p>
                    <p className="text-gray-700 leading-relaxed mb-4">{item.description}</p>
                    
                    {item.achievements && (
                      <div className="mt-3 space-y-2">
                        <p className="text-xs font-bold text-gray-600 uppercase tracking-wide">Key Achievements:</p>
                        {item.achievements.map((achievement, idx) => (
                          <div key={idx} className="flex items-start gap-2">
                            <FaCheckCircle className="text-green-500 text-sm mt-1 flex-shrink-0" />
                            <p className="text-sm text-gray-600 leading-snug">{achievement}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bagian Skill */}
      <section id="skills" className="relative py-20 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">
            <span className="bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 bg-clip-text text-transparent">Main Skills</span>
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 text-center">
            {skills.map((skill, index) => (
              <div
                key={index}
                className="group relative backdrop-blur-xl bg-white/60 hover:bg-white/80 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-white/40 overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 via-blue-500/0 to-blue-500/0 group-hover:from-blue-500/10 group-hover:via-blue-500/10 group-hover:to-blue-500/10 transition-all duration-500"></div>
                <div className="relative z-10 py-6 px-2 flex flex-col items-center gap-3">
                  <div className="text-4xl text-blue-600 group-hover:scale-110 transition-transform duration-300">{skill.icon}</div>
                  <div className="font-bold text-gray-700 group-hover:text-blue-600 transition-colors text-center">{skill.label}</div>
                  {skill.level && (
                    <div className="flex flex-col items-center gap-1">
                      <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-2 py-1 rounded-full">{skill.level}</span>
                      <span className="text-xs text-gray-500">{skill.years} exp</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Section */}
      <section id="projects" className="relative py-20">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">
            <span className="bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 bg-clip-text text-transparent">My Projects</span>
          </h2>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {projects.map((project, index) => (
              <div
                key={index}
                className="group relative backdrop-blur-xl bg-white/70 rounded-2xl shadow-lg hover:shadow-2xl overflow-hidden transform transition-all duration-300 hover:-translate-y-2 border border-white/40 cursor-pointer"
                onClick={() => openModal(project)}
              >
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 via-blue-500/0 to-pink-500/0 group-hover:from-blue-500/10 group-hover:via-blue-500/10 group-hover:to-pink-500/10 transition-all duration-500"></div>
                <div className="relative overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  {project.isLive && (
                    <div className="absolute top-3 left-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg animate-pulse">
                      LIVE APP
                    </div>
                  )}
                  {project.stats && (
                    <div className="absolute top-3 right-3 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">
                      {project.stats.status}
                    </div>
                  )}
                </div>
                <div className="relative z-10 p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
                    {project.title}
                  </h3>
                  <p className="text-gray-600 mb-3 leading-relaxed text-sm">
                    {project.description}
                  </p>
                  
                  {project.tech && (
                    <div className="flex flex-wrap gap-2 mb-3">
                      {project.tech.map((tech, idx) => (
                        <span key={idx} className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded-full font-semibold">
                          {tech}
                        </span>
                      ))}
                    </div>
                  )}
                  
                  {project.stats && (
                    <div className="flex gap-4 text-xs text-gray-500 mb-3">
                      <div className="flex items-center gap-1">
                        <FaCode className="text-blue-500" />
                        <span>{project.stats.duration}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <FaUsers className="text-blue-500" />
                        <span>{project.stats.team}</span>
                      </div>
                    </div>
                  )}
                  
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-blue-600 group-hover:gap-2 transition-all">
                    {project.isLive ? 'Buka Aplikasi' : 'View Details'}
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {selectedProject && (
          <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-md flex justify-center items-center z-[9999] p-4">
            <div className="relative backdrop-blur-xl bg-white/90 p-8 rounded-3xl max-w-3xl w-full shadow-2xl border border-white/40 animate-fade-in max-h-[90vh] overflow-y-auto">
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-red-500 hover:bg-red-600 text-white rounded-full text-xl font-bold transition-all duration-300 transform hover:scale-110 hover:rotate-90 shadow-lg z-10"
              >
                &times;
              </button>
              <img
                src={selectedProject.image}
                alt={selectedProject.title}
                className="w-full h-64 object-cover rounded-xl shadow-lg"
              />
              <div className="mt-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-blue-600 bg-clip-text text-transparent">
                    {selectedProject.title}
                  </h3>
                  {selectedProject.stats && (
                    <span className="bg-green-500 text-white text-sm font-bold px-3 py-1 rounded-full">
                      {selectedProject.stats.status}
                    </span>
                  )}
                </div>
                
                <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                  {selectedProject.description}
                </p>
                
                {selectedProject.tech && (
                  <div className="mb-6">
                    <h4 className="text-sm font-bold text-gray-600 uppercase tracking-wide mb-3">Technology Stack</h4>
                    <div className="flex flex-wrap gap-2">
                      {selectedProject.tech.map((tech, idx) => (
                        <span key={idx} className="bg-gradient-to-r from-blue-500 to-blue-500 text-white text-sm px-4 py-2 rounded-full font-semibold shadow-md">
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                
                {selectedProject.stats && (
                  <div className="grid grid-cols-3 gap-4 mb-6">
                    <div className="bg-gradient-to-br from-blue-50 to-blue-50 p-4 rounded-xl text-center">
                      <FaCode className="text-2xl text-blue-600 mx-auto mb-2" />
                      <div className="text-sm text-gray-600">Duration</div>
                      <div className="text-lg font-bold text-gray-800">{selectedProject.stats.duration}</div>
                    </div>
                    <div className="bg-gradient-to-br from-blue-50 to-blue-50 p-4 rounded-xl text-center">
                      <FaUsers className="text-2xl text-blue-600 mx-auto mb-2" />
                      <div className="text-sm text-gray-600">Team Size</div>
                      <div className="text-lg font-bold text-gray-800">{selectedProject.stats.team}</div>
                    </div>
                    <div className="bg-gradient-to-br from-blue-50 to-pink-50 p-4 rounded-xl text-center">
                      <FaRocket className="text-2xl text-blue-600 mx-auto mb-2" />
                      <div className="text-sm text-gray-600">Status</div>
                      <div className="text-lg font-bold text-gray-800">{selectedProject.stats.status}</div>
                    </div>
                  </div>
                )}
                
                {selectedProject.isLive ? (
                  <Link
                    to={selectedProject.link}
                    className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-600 via-green-600 to-teal-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                  >
                    <FaRocket className="text-xl" />
                    Buka Aplikasi
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </Link>
                ) : (
                  <a
                    href={selectedProject.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                  >
                    <FaRocket className="text-xl" />
                    View
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
      </section>

      {/* Tentang Saya */}
        <section id="about" className="relative py-20 px-6">
        <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl sm:text-5xl font-extrabold mb-12 text-center">
            <span className="bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 bg-clip-text text-transparent">About Me</span>
            </h2>
            
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="backdrop-blur-xl bg-white/70 p-8 rounded-2xl shadow-lg border border-white/40">
                <div className="text-gray-700 text-lg leading-relaxed space-y-4 text-justify">
                  <p>
                    I currently work as a <span className="font-semibold text-blue-600">Technical Project Admin</span> and also as a 
                    <span className="font-semibold text-blue-600"> Freelance Developer</span> with a strong passion for creating digital solutions that are not only functional and scalable but also deliver exceptional user experiences.
                  </p>
                  <p>
                    With <strong className="text-blue-600">5+ years of experience</strong> in the technology industry, I have collaborated with diverse cross-functional teams to build and manage high-quality web applications used by thousands of users every day. My role extends beyond development, encompassing process coordination, technical communication, documentation, and ensuring smooth project delivery.
                  </p>
                  <p>
                    As a developer, I focus on <strong className="text-blue-600">clean architecture</strong>, 
                    <strong className="text-blue-600"> performance optimization</strong>, and 
                    <strong className="text-blue-600"> best practices</strong> in modern web application development development. Even as a freelance developer, I consistently maintain high standards of professionalism, efficiency, and product quality.
                  </p>
                  <p>
                    I believe that technology is not just about building features—it is about creating meaningful experiences for users.
                  </p>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="backdrop-blur-xl bg-gradient-to-br from-blue-50/80 to-blue-50/80 p-6 rounded-2xl shadow-lg border border-white/40">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-600 rounded-xl flex items-center justify-center">
                      <FaCode className="text-white text-xl" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">Development Philosophy</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Code with purpose, design with empathy, and deliver with excellence. Setiap baris kode adalah investasi untuk masa depan produk.
                  </p>
                </div>
                
                <div className="backdrop-blur-xl bg-gradient-to-br from-blue-50/80 to-blue-50/80 p-6 rounded-2xl shadow-lg border border-white/40">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-600 rounded-xl flex items-center justify-center">
                      <FaRocket className="text-white text-xl" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">Continuous Learning</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Technology evolves rapidly, and so do I. Aktif mempelajari teknologi terbaru dan best practices untuk tetap relevan di industri.
                  </p>
                </div>
                
                <div className="backdrop-blur-xl bg-gradient-to-br from-blue-50/80 to-pink-50/80 p-6 rounded-2xl shadow-lg border border-white/40">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-pink-600 rounded-xl flex items-center justify-center">
                      <FaUsers className="text-white text-xl" />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">Team Collaboration</h3>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    Great products are built by great teams. Percaya pada komunikasi terbuka, code review yang konstruktif, dan knowledge sharing.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Values */}
            <div className="backdrop-blur-xl bg-white/70 p-8 rounded-2xl shadow-lg border border-white/40">
              <h3 className="text-2xl font-bold text-center mb-8 bg-gradient-to-r from-blue-600 to-blue-600 bg-clip-text text-transparent">
                Core Values
              </h3>
              <div className="grid md:grid-cols-4 gap-6 text-center">
                <div className="group">
                  <div className="w-16 h-16 mx-auto mb-3 bg-gradient-to-br from-blue-500 to-blue-500 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <FaCheckCircle className="text-white text-2xl" />
                  </div>
                  <h4 className="font-bold text-gray-800 mb-2">Quality First</h4>
                  <p className="text-sm text-gray-600">Code quality and user experience are our highest priorities</p>
                </div>
                
                <div className="group">
                  <div className="w-16 h-16 mx-auto mb-3 bg-gradient-to-br from-blue-500 to-blue-500 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <FaRocket className="text-white text-2xl" />
                  </div>
                  <h4 className="font-bold text-gray-800 mb-2">Innovation</h4>
                  <p className="text-sm text-gray-600">Continuously seeking creative solutions and the latest technologies</p>
                </div>
                
                <div className="group">
                  <div className="w-16 h-16 mx-auto mb-3 bg-gradient-to-br from-blue-500 to-pink-500 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <FaUsers className="text-white text-2xl" />
                  </div>
                  <h4 className="font-bold text-gray-800 mb-2">Collaboration</h4>
                  <p className="text-sm text-gray-600">Strong team collaboration leads to the best products</p>
                </div>
                
                <div className="group">
                  <div className="w-16 h-16 mx-auto mb-3 bg-gradient-to-br from-pink-500 to-red-500 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <FaStar className="text-white text-2xl" />
                  </div>
                  <h4 className="font-bold text-gray-800 mb-2">Excellence</h4>
                </div>
              </div>
            </div>
        </div>
        </section>

      {/* Contact Section */}
      <section id="contact" className="relative py-20 px-6 bg-gradient-to-br from-blue-50/50 via-blue-50/50 to-blue-50/50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl sm:text-5xl font-extrabold mb-6">
            <span className="bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 bg-clip-text text-transparent">Mari Berkolaborasi</span>
          </h2>
          <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
            Tertarik untuk berkolaborasi atau ingin tahu lebih lanjut tentang proyek-proyek saya? Hubungi saya melalui platform di bawah ini.
          </p>
          
          <div className="grid md:grid-cols-3 gap-6 mb-12 max-w-3xl mx-auto">
            <a 
              href="mailto:bayuakbar41@gmail.com"
              className="backdrop-blur-xl bg-white/70 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-white/40 group"
            >
              <div className="relative w-20 h-20 mx-auto mb-4">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-500 rounded-full blur-lg opacity-50 group-hover:opacity-75 transition-opacity duration-300"></div>
                <div className="relative w-20 h-20 bg-gradient-to-br from-blue-500 via-blue-500 to-blue-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <FaEnvelope className="text-white text-3xl" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Email</h3>
              <p className="text-gray-600 text-sm">bayuakbar41@gmail.com</p>
            </a>
            
            <a 
              href="https://github.com/bayuu21"
              target="_blank"
              rel="noopener noreferrer"
              className="backdrop-blur-xl bg-white/70 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-white/40 group"
            >
              <div className="relative w-20 h-20 mx-auto mb-4">
                <div className="absolute inset-0 bg-gradient-to-r from-gray-600 to-gray-800 rounded-full blur-lg opacity-50 group-hover:opacity-75 transition-opacity duration-300"></div>
                <div className="relative w-20 h-20 bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <FaGithub className="text-white text-3xl" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">GitHub</h3>
              <p className="text-gray-600 text-sm">Bayu Muhammad Akbar</p>
            </a>
            
            <a 
              href="https://linkedin.com/in/bayumuhammadakbar"
              target="_blank"
              rel="noopener noreferrer"
              className="backdrop-blur-xl bg-white/70 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-white/40 group"
            >
              <div className="relative w-20 h-20 mx-auto mb-4">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-700 rounded-full blur-lg opacity-50 group-hover:opacity-75 transition-opacity duration-300"></div>
                <div className="relative w-20 h-20 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-700 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <FaLinkedin className="text-white text-3xl" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">LinkedIn</h3>
              <p className="text-gray-600 text-sm">Bayu Muhammad Akbar</p>
            </a>
          </div>
          
          <div className="backdrop-blur-xl bg-white/70 p-8 rounded-2xl shadow-lg border border-white/40">
            <p className="text-gray-700 text-lg mb-6">
              <strong className="text-blue-600">Let's build something amazing together!</strong>
            </p>
            <p className="text-gray-600 leading-relaxed">
              Saya selalu terbuka untuk project-project menarik, kolaborasi, atau sekedar diskusi tentang teknologi. 
              Jangan ragu untuk menghubungi saya!
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-gradient-to-r from-gray-100 via-gray-100 to-gray-00 text-white py-4">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-gray-400 mb-4">
            © 2024 Bayu Muhammad Akbar. All rights reserved.
          </p>
          {/* <div className="flex justify-center gap-8">
            <a href="https://github.com/bayuakbar" target="_blank" rel="noopener noreferrer" className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-600 to-gray-800 rounded-full blur-md opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
              <div className="relative w-12 h-12 bg-gradient-to-br from-gray-700 to-gray-900 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <FaGithub className="text-white text-2xl" />
              </div>
            </a>
            <a href="mailto:bayuakbar@gmail.com" className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-500 rounded-full blur-md opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
              <div className="relative w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <FaEnvelope className="text-white text-2xl" />
              </div>
            </a>
            <a href="https://linkedin.com/in/bayuakbar" target="_blank" rel="noopener noreferrer" className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-700 rounded-full blur-md opacity-0 group-hover:opacity-50 transition-opacity duration-300"></div>
              <div className="relative w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <FaLinkedin className="text-white text-2xl" />
              </div>
            </a>
          </div> */}
        </div>
      </footer>

      
      <style>{`
        @keyframes float {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -30px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        
        @keyframes float-delayed {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(-25px, 25px) scale(1.05); }
          66% { transform: translate(20px, -15px) scale(0.95); }
        }
        
        @keyframes float-slow {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(-15px, -25px) scale(1.08); }
        }
        
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
        
        .animate-float-delayed {
          animation: float-delayed 10s ease-in-out infinite;
          animation-delay: 1s;
        }
        
        .animate-float-slow {
          animation: float-slow 12s ease-in-out infinite;
          animation-delay: 2s;
        }
      `}</style>
    </div>
  )
}
